const API_HOSTS = {
    production: 'https://leadtheway.sk/V1/public/index.php',
    development: 'https://develop.leadtheway.sk/V1/public/index.php',
    local: 'http://localhost:8080',
};

const normalizeTarget = (value) => {
    if (!value) {
        return null;
    }

    const normalized = value.toLowerCase();
    if (normalized === 'prod') {
        return 'production';
    }
    if (normalized === 'dev') {
        return 'development';
    }
    if (normalized === 'qa') {
        return 'development';
    }
    return normalized;
};

export const getApiTarget = () => {
    const envTarget = normalizeTarget(process.env.REACT_APP_API_TARGET);

    if (envTarget && API_HOSTS[envTarget]) {
        return envTarget;
    }

    return process.env.NODE_ENV === 'production' ? 'production' : 'local';
};

export const getApiHost = () => API_HOSTS[getApiTarget()];

export const API_TARGET = getApiTarget();
export const HOST = getApiHost();
export const PROD_HOST = API_HOSTS.production;
export const LOCAL_HOST = API_HOSTS.local;

const ALLOWED_MEDIA_ORIGINS = new Set(Object.values(API_HOSTS).map((host) => new URL(host).origin));

export const resolveMediaUrl = (path) => {
    if (!path) {
        return '/no_photo.jpg';
    }

    if (path.startsWith('//')) {
        return '/no_photo.jpg';
    }

    if (/^https?:\/\//i.test(path)) {
        try {
            const mediaUrl = new URL(path);
            return ALLOWED_MEDIA_ORIGINS.has(mediaUrl.origin) ? mediaUrl.href : '/no_photo.jpg';
        } catch (error) {
            return '/no_photo.jpg';
        }
    }

    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    const isUploadedMediaPath =
        normalizedPath.startsWith('/upload/') || normalizedPath.startsWith('/public/upload/');

    if (!isUploadedMediaPath) {
        return normalizedPath;
    }

    if (API_TARGET === 'local') {
        const localPath = normalizedPath.startsWith('/public/')
            ? normalizedPath.replace('/public', '')
            : normalizedPath;

        return `${LOCAL_HOST}${localPath}`;
    }

    if (normalizedPath.startsWith('/upload/')) {
        return `/public${normalizedPath}`;
    }

    return normalizedPath;
};
